import { action, payload } from 'ts-action'
import { IFeaturedShiftsCampaign } from 'models/FeaturedShiftsCampaign'

export const FeaturedShiftsCampaignsFetching = action(
  'FeaturedShiftsCampaignsFetching',
  payload<boolean>(),
)
export const GetFeaturedShiftsCampaign = action(
  'GetFeaturedShiftsCampaign',
  payload<IFeaturedShiftsCampaign>(),
)
export const ClearFeaturedShiftsCampaignReducer = action(
  'ClearFeaturedShiftsCampaignReducer',
)
